const env = process.env.RAILS_ENV
const envPath = env === 'development' ? '' : `/${env}`
const domain = window.OctolyImagesDomain || window.location.origin

export const SKEEPERS_UI_ASSET_PATH = `${domain}${envPath}/packs/skeepers-ui-core/`
export const STORE_ID = window.STORE_ID
export const CLIENT_ID = window.CLIENT_ID
export const CURRENT_STORE = window.CURRENT_STORE
export const CREATOR_EXPLORER_ENABLED = window.CREATOR_EXPLORER_ENABLED === true
export const CURRENT_USER = window.CURRENT_USER
export const CAN_EDIT_STORE = CURRENT_USER?.can_edit_store === true
export const apolloInitialCache = window.apolloInitialCache

export default {
  SKEEPERS_UI_ASSET_PATH,
  STORE_ID,
  CLIENT_ID,
  CURRENT_STORE,
  CREATOR_EXPLORER_ENABLED,
  CURRENT_USER,
  CAN_EDIT_STORE,
  apolloInitialCache,
}
